import analytics from "@pcln/analytics";
class Analytics {
    chatbotContext;
    init(data) {
        this.chatbotContext = data;
    }
    fireGA4Event(ga4EventParams) {
        try {
            analytics.GA4Enabled = true;
            analytics.logEvent(ga4EventParams);
        } finally{
            analytics.GA4Enabled = false;
        }
    }
    logError(logData) {
        analytics.logError({
            ...this.getBaseAttributes(),
            ...logData
        });
    }
    log({ message = '', ...rest }) {
        analytics.log({
            message,
            ...this.getBaseAttributes(),
            ...rest
        });
    }
    logWarning({ name = '', message = '' }) {
        analytics.logWarning({
            name,
            message,
            ...this.getBaseAttributes()
        });
    }
    getBaseAttributes() {
        const isBrowser = 'undefined' != typeof window;
        const componentVersionFromWindow = isBrowser ? window?.PCLN_BOOTSTRAP_DATA?.moduleInfo?.['@pcln/penny-chat-bot'] : 'unknown';
        return {
            component: 'PennyChatbot',
            componentVersion: this.chatbotContext?.componentVersion || componentVersionFromWindow,
            requestFrom: this.chatbotContext?.fetchRequestOptions?.headers?.['x-request-from'],
            productId: this.chatbotContext?.submitChatMessagesPayload?.productId,
            cguid: this.chatbotContext?.submitChatMessagesPayload?.cguid,
            rguid: this.chatbotContext?.submitChatMessagesPayload?.rguid
        };
    }
}
const analytics_analytics = new Analytics();
export { Analytics, analytics_analytics as default };
